var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenCheckConnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1425 3.28219L8.3925 0.949687C8.775 0.777188 9.225 0.777188 9.6075 0.949687L14.8575 3.28219C15.3975 3.52219 15.75 4.06219 15.75 4.65469V8.17969C15.75 12.3422 12.87 16.2347 9 17.1797C5.13 16.2347 2.25 12.3422 2.25 8.17969V4.65469C2.25 4.06219 2.6025 3.52219 3.1425 3.28219ZM5.025 10.2047L6.9675 12.1472C7.26 12.4397 7.74 12.4397 8.025 12.1472L12.9675 7.20469C13.26 6.91219 13.26 6.43969 12.9675 6.14719C12.675 5.85469 12.2025 5.85469 11.91 6.14719L7.5 10.5572L6.0825 9.14719C5.79 8.85469 5.3175 8.85469 5.025 9.14719C4.88456 9.28731 4.80564 9.47755 4.80564 9.67594C4.80564 9.87433 4.88456 10.0646 5.025 10.2047Z",
    fill: "#38761E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckConnected);
export default __webpack_public_path__ + "static/media/greenCheckConnected.cc5a5c4d12779c9c81b04b567726830e.svg";
export { ForwardRef as ReactComponent };